import React from 'react'

import {
  commonAttributes,
  indianStatesJson,
  tableColumnDefaultOption,
  uploadPresets
} from 'app/config'
import constants from 'app/constants'
import { validatePercentage } from 'app/validators'

import { columns as commonColumns } from '../common'

const property_paths = [
  'user.uuid',
  'user.phone_number',
  'user.first_name',
  'user.last_name',
  'user.email_address',
  'user.address',
  'user.bio',
  'user.date_of_birth'
]

// Columns inherited from common.js that should remain editable in the modal
// but hidden from the row-scanning table view. Toggle off via the modal's
// "edit" affordance, not by re-showing them here.
const HIDE_ON_TABLE = new Set([
  'user.address',
  'user.bio',
  'user.date_of_birth'
])

const inheritedColumns = commonColumns
  .filter((item) => property_paths.includes(item.name))
  .map((item) =>
    HIDE_ON_TABLE.has(item.name)
      ? { ...item, options: { ...item.options, display: false } }
      : item
  )

export const columns = [
  ...inheritedColumns,
  {
    ...commonColumns.find((item) => ['user'].includes(item.name)),
    modalEdit: false,
    editable: false,
    disabledInFormOnEdit: true,
    disabledInFormOnCreate: true,
    options: {
      ...commonColumns.find((item) => ['user'].includes(item.name)).options,
      display: false
    }
  },
  {
    ...commonAttributes.image,
    // NESTED, like every other role's form. This was `user_image`, a flat key
    // that appears nowhere in the teacher payload -- the API returns the photo
    // at `user.image` (GetUserSerializer). So the field could never show a
    // teacher's existing picture: it read undefined, rendered no preview, and
    // the button said "upload" on a teacher who already had one. Student,
    // Parent and commonAttributes all use `user.image`; Teacher was the outlier.
    name: 'user.image',
    label: 'Profile Picture',
    fileUrlOnly: true,
    uploadPreset: uploadPresets[constants.USER],
    options: {
      ...tableColumnDefaultOption.options,
      display: false
    }
  },
  {
    ...tableColumnDefaultOption,
    name: 'state',
    label: 'state',
    widget: 'select',
    widgetFilter: true,
    valueLabelMappings: indianStatesJson,
    modalEdit: true,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'state',
      customBodyRender: (value) => <span>{indianStatesJson[value]}</span>
    }
  },
  {
    // A teacher is mapped to a centre (derived from their batches) and/or to
    // one or more apartments. Read-only here; edited from the apartment module.
    name: 'complexes',
    label: 'Apartments',
    widgetFilter: true,
    modalEdit: false,
    disabledInForm: true,
    options: {
      ...tableColumnDefaultOption.options,
      // ?apartment=<slug|uuid> — see TeacherFilter.apartment_filter
      filterKey: 'apartment',
      customBodyRender: (value) =>
        value && value.length ? (
          <span>{value.map((a) => a.name).join(', ')}</span>
        ) : null
    }
  },
  {
    name: 'oh_share_ts',
    label: 'Oh Share (Source teacher)',
    validate: validatePercentage,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      display: false
    }
  },
  {
    name: 'oh_share_ohs',
    label: 'Oh Share (Source oh)',
    validate: validatePercentage,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      display: false
    }
  },
  {
    name: 'dispatch_rate_per_session_ohs',
    label: 'Dispatch Rate (openhouse)',
    validate: validatePercentage,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      display: false
    }
  },
  {
    name: 'dispatch_rate_per_session_ts',
    label: 'Dispatch Rate (teacher)',
    validate: validatePercentage,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      display: false
    }
  }
]
